import React, { FC, useEffect, useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@material-ui/core';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ScheduleNoticeModal: FC<ModalProps> = (props: ModalProps) => {
    const [open, setOpen] = useState(false);
    const { isOpen, onClose } = props;

    useEffect(() => {
        setOpen(isOpen);
    }, [isOpen]);

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Envío fuera de horario</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div>
                        <span>
                            Los horarios disponibles son de <strong>Lunes a Viernes</strong> de <strong>10:00 a.m</strong> a <strong>6:00 p.m</strong>.
                        </span>
                        <br/>
                        <span>
                            Verificar horario seleccionado.
                        </span>
                    </div>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color='secondary'>
                    ACEPTAR
                </Button>
            </DialogActions>
        </Dialog>
    );
};
